var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vap-btng"},_vm._l((_vm.options),function(item,id,i){return _c('div',{key:id,staticClass:"vap-btng-cell",class:[
            {'vap-btng-first' : i == 0},
            {'vap-btng-last' : i == Object.keys(_vm.options).length - 1},
            {'vap-btng-middle' : i != 0 && i != Object.keys(_vm.options).length - 1},
            {'vap-btng-selected' : _vm.value[id]} ]},[_c('div',{staticClass:"vap-btng-item",on:{"click":function($event){return _vm.handleClick(id)}}},[_c('label',[_vm._v(_vm._s(item.label))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }